/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/itp-export/QaItpSendConfirmDialog.tsx
 * FILE_ID: JOBHUB-QA-ITP-SEND-CONFIRM-001
 * PURPOSE: Show the email details and wait for a second Send before the message goes out.
 */
export function QaItpSendConfirmDialog({
  open,
  to,
  subject,
  message,
  from,
  cc,
  bcc,
  onCancel,
  onSend,
}: {
  open: boolean
  to: string
  subject: string
  message: string
  from: string
  cc: string
  bcc: string
  onCancel: () => void
  onSend: () => void
}) {
  if (!open) return null
  const line = (label: string, value: string) => (
    <p className="text-sm text-foreground">
      <span className="text-muted-foreground">{label}: </span>
      {value || '—'}
    </p>
  )
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/50 p-4">
      <div role="dialog" aria-label="Confirm send" className="max-h-[80vh] w-full max-w-md overflow-y-auto rounded-xl border border-border bg-card p-4">
        <h2 className="text-sm font-semibold text-foreground">Send this ITP?</h2>
        <div className="mt-3 space-y-1">
          {line('To', to)}
          {line('Subject', subject)}
          {line('Message', message)}
          {line('From', from)}
          {line('Cc', cc)}
          {line('Bcc', bcc)}
        </div>
        <div className="mt-4 flex justify-end gap-2">
          <button type="button" onClick={onCancel} className="rounded-md border border-border px-3 py-1.5 text-xs font-medium">
            Cancel
          </button>
          <button type="button" onClick={onSend} className="rounded-md bg-primary px-3 py-1.5 text-xs font-medium text-primary-foreground">
            Send
          </button>
        </div>
      </div>
    </div>
  )
}
